<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">계약관리</span>
            <span class="txt">핏투데이케어에 가입한 업체 계약 및 결제정보 등록, 수정, 삭제가 가능합니다.</span>
        </div>

        <div class="com-table-top">
            <span class="title">환불등록</span>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">계약정보</span></span>
            <div class="info-edit-table">
                <div class="table-wrapper">
                    <table>
                        <colgroup>
                            <col style="width: 156px" />
                            <col style="width: auto" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    센터
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input :value="centerInfo.centerName" class="w400" disabled type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>상품</th>
                                <td>
                                    <!--<select-form :select-data='["선택"]' class="w240" disabled></select-form>-->
                                    <div class="input-line">
                                        <input
                                            v-model="editField.contractProductName"
                                            class="w400"
                                            disabled
                                            type="text"
                                        />
                                    </div>
                                    <table class="sub-table">
                                        <colgroup>
                                            <col style="width: 150px" />
                                            <col style="width: auto" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>사용기간</th>
                                                <td>
                                                    <div class="com-calendar-wrap">
                                                        <single-calendar
                                                            :start-date="editField.contractStartDate"
                                                            disabled
                                                        ></single-calendar>
                                                        <div class="com-dash"><span class="dash">~</span></div>
                                                        <single-calendar
                                                            :end-date="editField.contractEndDate"
                                                            @update="onUpdateContractEndDate"
                                                        ></single-calendar>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>계약금액</th>
                                                <td>
                                                    <input
                                                        :value="editField.contractPrice | numberFormatFilter"
                                                        class="w130"
                                                        disabled
                                                        type="text"
                                                    />
                                                    <span class="txt">원</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>환불금액</th>
                                                <td>
                                                    <input
                                                        v-model="editField.returnPrice"
                                                        class="w130"
                                                        type="text"
                                                        @keypress="isNumber($event)"
                                                        @keyup="onKeyUpReturnPrice"
                                                    />
                                                    <span class="txt">원</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>환불수단</th>
                                                <td>
                                                    <div class="com-radio">
                                                        <input
                                                            id="radio-1-1"
                                                            v-model="editField.returnPayType"
                                                            checked
                                                            name="radio-1"
                                                            type="radio"
                                                            value="B"
                                                        />
                                                        <label for="radio-1-1">계좌</label>
                                                    </div>
                                                    <div class="com-radio">
                                                        <input
                                                            id="radio-1-2"
                                                            v-model="editField.returnPayType"
                                                            name="radio-1"
                                                            type="radio"
                                                            value="L"
                                                        />
                                                        <label for="radio-1-2">현금</label>
                                                    </div>
                                                    <div class="com-radio">
                                                        <input
                                                            id="radio-1-3"
                                                            v-model="editField.returnPayType"
                                                            name="radio-1"
                                                            type="radio"
                                                            value="C"
                                                        />
                                                        <label for="radio-1-3">카드</label>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <th>환불일자</th>
                                <td>
                                    <single-calendar :start-date="editField.returnExecAt"></single-calendar>
                                </td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td>
                                    <textarea v-model="editField.returnMemo" class="com-textarea"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn" @click="onClickCancel">취소</button>
                    <button class="com-btn blue" @click="onClickContractProductReturn">등록</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'businessContractRefund',
    props: {},
    computed: {
        today() {
            return moment().format('YYYY-MM-DD');
        },
    },
    data() {
        return {
            contractId: parseInt(this.$route.params.contractId),
            productId: parseInt(this.$route.params.productId),
            contractInfo: {},
            centerInfo: {},
            productInfo: {},
            editField: {
                contractProductName: '',
                contractEndDate: '',
                returnPayType: 'C',
                returnPrice: 0,
                contractPrice: 0,
                returnExecAt: '',
                returnMemo: '',
            },
        };
    },
    mounted() {
        this.init();
        console.log(this.editField.returnExecAt, this.today);
    },
    methods: {
        async init() {
            await this.getContractInfo();
            await this.getCenterInfo();

            this.editField.returnExecAt = this.today;
        },
        async getContractInfo() {
            try {
                const { data } = await this.sendGetFtContract();
                this.contractInfo = data;

                // 연장 상품 선택
                const { ftContractProducts } = data;
                for (const p of ftContractProducts) {
                    if (this.productId == p.ftProductId) {
                        this.productInfo = p;
                        break;
                    }
                }

                this.editField.contractProductName = this.productInfo.ftProductName;
                this.editField.contractPrice = this.productInfo.ftProductBuyPrice;
                this.editField.contractStartDate = this.productInfo.contractStartDate;
                this.editField.contractEndDate = this.productInfo.contractEndDate;

                if (this.productInfo.ftProductType === 'M') {
                    // 문자서비스인 경우, 상품명에 텍스트 추가
                    this.editField.contractProductName = `문자서비스 ${this.editField.contractProductName}`;
                }

                console.log('===> Success Loading : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendGetFtContract() {
            return api.get(`/admin/api/ft/contract/${this.contractId}`);
        },
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;

                console.log('===> Success Loading : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.contractInfo.centerId}`);
        },
        onClickCancel() {
            this.$router.push({ path: `/madmin/business/contract/detail/${this.contractInfo.centerId}` });
        },
        onClickContractProductReturn() {
            const { getPureNumber } = this;
            const { contractPrice, returnPrice } = this.editField;

            if (getPureNumber(contractPrice) < getPureNumber(returnPrice)) {
                alert('환불금액은 계약금액보다 클 수 없습니다.');
                return false;
            }

            if (!confirm('환불내용을 등록하시겠습니까?')) {
                return false;
            }

            this.refundProduct();
        },
        async refundProduct() {
            try {
                const { data } = await this.sendPutFtContractProductReturn();
                alert('환불이 등록되었습니다.');

                this.$router.push({ path: `/madmin/business/contract/detail/${this.contractInfo.centerId}` });
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendPutFtContractProductReturn() {
            const { contractId, productId } = this;
            const params = this.getParams();
            return api.put(`/admin/api/ft/contract/${contractId}/contract-product/${productId}/return`, {
                ...params,
            });
        },
        getParams() {
            const { contractEndDate, returnPayType, returnPrice, returnExecAt, returnMemo } = this.editField;
            const price = this.getPureNumber(returnPrice);
            const params = {
                centerId: this.contractInfo.centerId,
                contractEndDate,
                returnPrice: price,
                returnPayType,
                returnExecAt,
                returnMemo,
            };
            return params;
        },
        onUpdateContractEndDate(d) {
            this.editField.contractEndDate = d;
        },
        onKeyUpReturnPrice() {
            const num = this.getPureNumber(this.editField.returnPrice);
            this.editField.returnPrice = this.getNumberFormat(num);
        },
        getPureNumber(num) {
            num = num === '' ? 0 : num;
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        getNumberFormat(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    },
};
</script>
<style lang="scss"></style>
